<template>
	<div class="performance-graph">
		<div
			ref="performanceGraph"
			style="width: 100%; height: 100%; overflow: hidden"
		></div>
	</div>
</template>

<script>
const eCharts = require("echarts");
export default {
	name: "performanceGraph",
	props: {
		reportsTable: Array,
		labelsData: String,
		dataList: Array,
		CountryAverege: Array,
		show_report: Boolean,
		selectType: String,
	},
	data() {
		return {
			performanceGraphInstance: "",
			option: {
				dataZoom: [
					{
						show: false,
						startValue: 0,
						endValue: 9,
						height: 20,
						zoomLock: true,
						zoomOnMouseWheel: false,
						moveOnMouseMove: false,
						moveOnMouseWheel: true,
						preventDefaultMouseMove: true,
					},
					{
						height: 20,
						type: "slider",
						startValue: 0,
						endValue: 100,
						zoomLock: true,
						labelFormatter: "",
						moveOnMouseWheel: true,
					},
					{
						show: false,
						yAxisIndex: 0,
						filterMode: "empty",
						width: 30,
						height: "100%",
						showDataShadow: false,
						zoomLock: true,
						left: "93%",
					},
				],
				color: ["#d26300", "#ffc897"],
				tooltip: {
					trigger: "axis",
					axisPointer: {
						type: "shadow",
					},
					formatter: (p) => {
						let colorSpan =
							'<span style="display:inline-block;margin-right:30px;border-radius:2px;width:9px;height:9px;"></span>';

						return `
						<span><u>${p[0].name}</u></span> <br />
						Occurance ${colorSpan}   ${this.getDataByRegion(p[0].axisValue, "total")} <br/>
						Completed   ${colorSpan}   ${this.getDataByRegion(
							p[0].axisValue,
							"completed"
						)} <br/>
						<span style="margin-left:15px"></span>  Points  ${colorSpan}  <span style="margin-left:20px"></span>  ${this.getDataByRegion(
							p[0].axisValue,
							"completed"
						)} of ${this.getDataByRegion(p[0].axisValue, "total_score")} <br/>
						<span style="margin-left:10px"></span> Score %   ${colorSpan}   <span style="margin-left:30px"></span>  ${this.getDataByRegion(
							p[0].axisValue,
							"score_completion_%"
						)} <br/>
						   ${colorSpan} 	<span style="margin-left:10px"></span> Completion %   <span style="margin-left:25px"></span>  ${this.getDataByRegion(
							p[0].axisValue,
							"completion_%"
						)} ${colorSpan}<br/>
						`;
					},
				},

				grid: {
					right: "10%",
					containLabel: true,
				},
				legend: {
					data: [""],
					textStyle: {
						fontSize: "16",
					},
				},
				xAxis: [
					{
						type: "category",
						axisTick: {
							alignWithLabel: true,
						},
						axisLabel: {
							interval: 0,
							rotate: 37, //If the label names are too long you can manage this by rotating the label.
							overflow: "truncate",
							margin: 8,
							hideOverlap: true,
							align: "right",
							verticalAlign: "top",
							lineHeight: 6,
							formatter: (value) => {
								if (value.includes("__")) {
									let labelArr = value.split("__");
									return `${this.excerptText(this.titleCase(labelArr[0]), 9)}\n
                                    ${this.excerptText(
																			this.titleCase(labelArr[1]),
																			9
																		)}`;
								} else {
									return this.excerptText(value, 9);
								}
							},
						},
						boundaryGap: true,
						// prettier-ignore
						data: [],
						textStyle: {
							fontSize: "14",
						},
					},
				],
				yAxis: [
					{
						type: "value",
						name: "",
						min: 0,
						interval: 20,
						max: 100,
						position: "left",
						alignTicks: true,
						axisLine: {
							show: false,
						},
						axisLabel: {
							formatter: "{value} %",
						},
					},
					{
						type: "value",
						name: "",
						min: 0,
						interval: 0,
						max: 1,
						position: "right",
						alignTicks: true,
						axisLine: {
							show: false,
						},
						axisLabel: {
							formatter: "{value} %",
						},
					},
				],
				series: [
					{
						label: {
							normal: {
								show: true,
								position: "top",
								padding: 20,
								fontSize: 9,
								formatter: "{c}%",
							},
						},
						name: ``,
						barGap: "80%",
						barCategoryGap: "80%",
						type: "bar",
						groupPadding: 100,
						yAxisIndex: 0,
						barWidth: "24%",
						data: [],
						showBackground: false,
						itemStyle: {
							// emphasis: {
							//     barBorderRadius: [50, 50]
							// },
							normal: {
								barBorderRadius: [8, 8, 0, 0],
							},
						},
					},
					{
						label: {
							normal: {
								show: true,
								position: "top",
								padding: 20,
								fontSize: 9,
								formatter: "{c}%",
							},
						},
						name: ``,
						barGap: "80%",
						barCategoryGap: "80%",
						type: "bar",
						groupPadding: 100,
						yAxisIndex: 0,
						barWidth: "24%",
						showBackground: false,
						data: [],
						itemStyle: {
							// emphasis: {
							//     barBorderRadius: [50, 50]
							// },
							normal: {
								barBorderRadius: [8, 8, 0, 0],
							},
						},
					},
					{
						name: "",
						type: "line",
						yAxisIndex: 1,
						lineStyle: {
							type: "dashed",
							width: 3,
							gap: 1,
						},
						color: "#7DAAF4",
						data: [],
					},
					{
						name: "",
						type: "line",
						yAxisIndex: 1,
						lineStyle: {
							type: "dashed",
							width: 3,
							gap: 1,
						},
						color: "#7DAAF4",
						data: [],
					},
				],
			},
		};
	},
	mounted() {
		setTimeout(() => {}, 1200);
	},
	watch: {
		show_report(val) {
			this.initGraph();
			this.$forceUpdate();
		},
	},
	methods: {
		excerptText(text, length = 10, clamp = "...") {
			return text.length > length
				? text.toString().slice(0, length) + clamp
				: text;
		},
		initGraph() {
			const chartContainer = this.$refs.performanceGraph;
			this.performanceGraphInstance = eCharts.init(chartContainer);
			let arr = [];
			let arr1 = [];

			let comp_arr = [];
			let comp_arr1 = [];

			// if (this.selectType != "completion") {
			[...this.dataList].map((el) => {
				if (el.total_score != 0) {
					arr.push(el["score_completion_%"]);
				}
			});
			[...this.CountryAverege].map((el) =>
				comp_arr.push(el["score_completion_%"])
			);
			// } else {
			[...this.dataList].map((el) => arr1.push(el["completion_%"]));
			this.CountryAverege.map((el) => comp_arr1.push(el["completion_%"]));
			// }
			let comp_val = 0;
			let comp_val1 = 0;

			comp_val = comp_arr[0];
			comp_val1 = comp_arr1[0];

			let comp_arr_val = [];
			let comp_arr_val1 = [];

			for (let i = 0; i < this.dataList.length; i++) {
				comp_arr_val.push(comp_val / 100);
				comp_arr_val1.push(comp_val1 / 100);
			}
			this.option.xAxis[0].data = JSON.parse(this.labelsData);
			this.option.series[0].data = arr;
			this.option.series[1].data = arr1;
			this.option.series[2].data = comp_arr_val;
			// this.option.series[3].data = comp_arr_val1;
			this.performanceGraphInstance.setOption(this.option);
			this.$forceUpdate();
			this.$emit("set_show_false");
		},
		getDataByRegion(region, key) {
			return this.dataList.find(
				(el) => el.name.toLowerCase() == region.toLowerCase()
			)[key];
		},
	},
};
</script>

<style>
.performance-graph {
	height: 500px;
}
#chart-container {
	background: #ffffff;
	position: relative;
	height: 90vh;
	overflow: hidden;
}
</style>
